import _ from 'lodash';
const isRequired = true;
const yesNoEnum = {
	type: 'enum',
	options: [
		{ display: 'Yes', value: 'yes' },
		{ display: 'No', value: 'no' },
	],
};

const genderEnum = {
	type: 'enum',
	options: [
		{ display: 'Male', value: 'male' },
		{ display: 'Female', value: 'female' },
		{ display: 'N/A', value: 'n/a' },
	],
};

const truckDrivingEnum = {
	type: 'enum',
	options: [
		{ display: 'Less than 6 months', value: 'lessThan6Months' },
		{ display: '1 to 2 years ', value: '1To2Years' },
		{ display: '2 to 3 years', value: '2To3Years' },
		{ display: '3 to 4 years', value: '3To4Years' },
		{ display: '4 to 5 years', value: '4To5Years' },
		{ display: '5 to 6 years', value: '5To6Years' },
		{ display: '6 to 7 years', value: '6To7Years' },
		{ display: '7 to 8 years', value: '7To8Years' },
		{ display: '8 to 9 years', value: '8To9Years' },
		{ display: '9 to 10 years', value: '9To10Years' },
		{ display: '10 or more years', value: '10OrMoreYears' },
	],
};

const fields = {
	anyInjuries: {
		path: 'anyInjuries',
		label: 'Any injuries',
		...yesNoEnum,
		isRequired,
	},
	bolNumber: {
		path: 'bolNumber',
		label: 'BOL Number',
		type: 'string',
	},
	commercialTruckDrivingExperience: {
		path: 'commercialTruckDrivingExperience',
		label: 'Commercial Truck Driving Experience',
		...truckDrivingEnum,
	},
	dateOfBirth: {
		path: 'dateOfBirth',
		label: 'Date of birth',
		type: 'dateYearPicker',
		isRequired,
	},
	dateOfHire: {
		path: 'dateOfHire',
		label: 'Date of hire',
		type: 'dateYearPicker',
		isRequired,
	},
	dateShiftStarted: {
		path: 'dateShiftStarted',
		label: 'Date Shift Started',
		type: 'date',
		isRequired,
	},
	dateOfIncident: {
		path: 'dateOfIncident',
		label: 'Date of Incident',
		type: 'date',
		isRequired,
	},
	dateOfWait: {
		path: 'dateOfWait',
		label: 'Date of Incident',
		type: 'date',
		defaultNow: true,
		isRequired,
	},
	driverSignature: {
		path: 'driverSignature',
		label: 'Type Name',
		type: 'string',
		isRequired,
	},
	fuelType: {
		path: 'fuelType',
		label: 'Fuel Type',
		type: 'string',
		isRequired,
	},
	siteLocation: {
		path: 'siteLocation',
		label: 'Site Location',
		type: 'string',
		isRequired,
	},
	orderConsignee: {
		path: 'orderConsignee',
		label: 'Consignee Of Order',
		type: 'string',
		isRequired,
	},
	siteCity: {
		path: 'siteCity',
		label: 'Site City',
		type: 'string',
		isRequired,
	},
	siteState: {
		path: 'siteState',
		label: 'Site State',
		type: 'string',
		isRequired,
	},
	reportedToSupervisor: {
		path: 'reportedToSupervisor',
		label: `Reported To supervisor (full name)`,
		type: 'string',
	},
	reportedToDispatch: {
		path: 'reportedToDispatch',
		label: `Reported To dispatch (full name)`,
		type: 'string',
	},
	shipperCustomer: {
		path: 'shipperCustomer',
		label: 'Shipper (Customer)',
		type: 'string',
	},
	signatureDate: {
		path: 'signatureDate',
		label: 'Date',
		type: 'date',
		defaultNow: true,
		isRequired,
	},
	baseTerminal: {
		path: 'baseTerminal',
		label: 'Base Terminal',
		type: 'string',
	},
	timeOfIncident: {
		path: 'timeOfIncident',
		label: 'Time of Incident',
		type: 'time',
		isRequired,
	},
	timeOfWait: {
		path: 'timeOfWait',
		label: 'Time of Incident',
		type: 'time',
		defaultNow: true,
		isRequired,
	},
	timeShiftStarted: {
		path: 'timeShiftStarted',
		label: 'Time Shift Started',
		type: 'time',
		isRequired,
	},
	totalGallons: {
		path: 'totalGallons',
		label: 'Total Gallons',
		type: 'string',
		isRequired,
	},
	truckTrailerNumber: {
		path: 'truckTrailerNumber',
		label: 'Truck / Trailer #',
		type: 'string',
	},
	tankTruckDrivingExperience: {
		path: 'tankTruckDrivingExperience',
		label: 'Total Fuel Tanker Delivery Experience',
		...truckDrivingEnum,
	},
};

const occupantsEnum = {
	type: 'enum',
	options: [
		{ display: '0', value: '0' },
		{ display: '1', value: '1' },
		{ display: '2', value: '2' },
		{ display: '3', value: '3' },
		{ display: '4', value: '4' },
		{ display: '5', value: '5' },
		{ display: '6', value: '6' },
		{ display: '7', value: '7' },
		{ display: '8', value: '8' },
		{ display: '9', value: '9' },
		{ display: '10+', value: '10+' },
	],
};

const vehicleFields = [
	[
		{ path: 'registeredName', label: 'Registered Name', type: 'string' },
		{ path: 'registeredPhoneNumber', label: 'Phone #', type: 'string' },
	],
	{
		path: 'registeredAddress',
		label: 'Registered Address',
		type: 'string',
	},
	[
		{ path: 'driverName', label: `Driver's Name`, type: 'string' },
		{ path: 'driverLicense', label: 'License #', type: 'string' },
	],
	{ path: 'driverAddress', label: 'Driver Address', type: 'string' },
	[
		{ path: 'vehicleMake', label: `Vehicle Make`, type: 'string' },
		{ path: 'vehicleYear', label: 'Vehicle Year', type: 'string' },
	],
	[
		{ path: 'bodyType', label: 'Body Type', type: 'string' },
		{ path: 'licenseNumber', label: 'License Plate #', type: 'string' },
	],
	[
		{ path: 'insuranceCarrier', label: 'Insurance Carrier', type: 'string' },
		{ path: 'wasVehicleTowed', label: 'Was vehicle towed?', ...yesNoEnum },
	],
	[
		{ path: 'adultOccupants', label: 'Adult Occupants', ...occupantsEnum },
		{ path: 'childOccupants', label: 'Child Occupants', ...occupantsEnum },
	],
	{
		path: 'damageExplained',
		label: 'Damage (Explain Extent)',
		type: 'multilineString',
		lines: 2,
		height: 8,
	},
];

const formGroups = {
	tripInfo: [
		{ section: 'Trip Info' },
		[fields.dateShiftStarted, fields.timeShiftStarted],
		[fields.truckTrailerNumber, fields.bolNumber],
		[fields.shipperCustomer, fields.baseTerminal],
		//[ fields.truckDrivingExperience ],
	],

	optionalTripInfo: [
		{ section: 'Trip Info' },
		[fields.dateShiftStarted, fields.timeShiftStarted],
		[fields.truckTrailerNumber],
		//[ fields.truckDrivingExperience ],
	],

	driverSignature: [{ section: 'Sign and Date' }, [fields.driverSignature, fields.signatureDate]],
	reportedTo: [{ section: 'Reported' }, fields.reportedToDispatch, fields.reportedToSupervisor],
	vehicle1: [],
	vehicle2: [],
	siteLocation: [fields.orderConsignee, [fields.siteCity, fields.siteState]],
};

const printGroups = {
	tripInfo: [
		[
			{ path: 'driverName', label: `Driver's Name`, basis: 50 },
			{ path: `truckTrailerNumber`, basis: 50 },
		],
		[
			{ path: 'dateShiftStarted', basis: 50 },
			{ path: 'timeShiftStarted', basis: 50 },
		],
		[{ path: 'shipperCustomer', basis: 50 }],
		[
			{ path: 'baseTerminal', basis: 50 },
			{ path: 'bolNumber', label: `BOL #` },
		],
	],

	optionalTripInfo: [
		[
			{ path: 'driverName', label: `Driver's Name`, basis: 50 },
			{ path: `truckTrailerNumber`, basis: 50 },
		],
		[
			{ path: 'dateShiftStarted', basis: 50 },
			{ path: 'timeShiftStarted', basis: 50 },
		],
	],
	vehicle1: [[{ special: 'vehicle1' }]],
	vehicle2: [[{ special: 'vehicle2' }]],
	siteLocation: [
		[{ path: 'orderConsignee' }],
		[
			{ path: 'siteCity', basis: 50 },
			{ path: 'siteState', basis: 50 },
		],
	],
};

['vehicle1', 'vehicle2'].forEach((key) => {
	formGroups[key] = _.cloneDeep(vehicleFields);
	formGroups[key].forEach((field) => {
		const fields = _.isArray(field) ? field : [field];
		const printRow = [];
		fields.forEach((field) => {
			const path = `${key}${_.upperFirst(field.path)}`;
			field.path = path;
			printRow.push({ path, height: field.height });
		});
		printGroups[key].push(printRow);
	});
});

const isPageBreak = true;
const questionMulti = {
	type: 'multilineString',
	lines: 5,
	isRequired,
};

const infoByReportType = {
	contamination: {
		title: 'Contamination (Blend) Report',
		formFields: [
			...formGroups.tripInfo,

			{ section: 'Incident Info' },
			[fields.dateOfIncident, fields.timeOfIncident],
			[fields.fuelType, fields.totalGallons],
			...formGroups.siteLocation,

			...formGroups.reportedTo,

			{ section: 'Details' },
			{
				path: 'contaminationExplanation',
				label: 'Explain in detail how above product was contaminated',
				type: 'multilineString',
				lines: 7,
				isRequired,
			},
			{
				path: 'howCouldHaveBeenPrevented',
				label: 'How could this contamination been prevented',
				type: 'multilineString',
				lines: 3,
				isRequired,
			},
			{
				path: 'actionTakenToCorrect',
				label: 'Action taken to correct contamination',
				type: 'multilineString',
				lines: 3,
				isRequired,
			},

			//
			//- questionnaire

			{ section: 'Mix Investigation Questionnaire' },
			{
				path: 'stationNumber',
				label: 'Station Number',
				type: 'string',
			},
			{
				path: 'productsInvolved',
				label: 'Products Involved',
				type: 'string',
			},
			{ section: 'History' },
			[fields.tankTruckDrivingExperience, fields.dateOfHire],
			{ section: 'Schedule' },
			[
				{
					path: 'dayShiftOrNightShift',
					label: 'Are you dayshift or nightshift driver? ',
					isRequired,
					type: 'enum',
					options: [
						{ display: 'Dayshift', value: 'dayshift' },
						{ display: 'Nightshift', value: 'nightshift' },
					],
				},
				{
					path: 'doYouRotate',
					label: 'Do you rotate shifts? ',
					...yesNoEnum,
					isRequired,
				},
			],
			[
				fields.timeShiftStarted,
				{
					path: 'didYouGetAdequateRest',
					label: 'Did you get adequate rest?',
					...yesNoEnum,
					isRequired,
				},
			],
			{
				path: 'whatTypeOfSchedule',
				label: 'What type of schedule are you on (5 on 2 off)?',
				type: 'string',
			},
			{
				path: 'howManyDaysHaveYouWorkedSinceLastDayOf',
				label: 'How many days have you worked since your last day off?',
				type: 'string',
			},
			{
				path: 'whatDayOfYourWorkWeekDidTheIncidentOccur',
				label: 'What day of your workweek did the incident occur (1 of 5; 2 of 4)?',
				type: 'string',
			},

			{ section: 'Truck / Equipment' },
			{
				path: 'doYouHaveAnAssignedTruck',
				label: 'Do you have an assigned truck?',
				...yesNoEnum,
				isRequired,
			},
			{
				path: 'wereYouOnYourAssignedTruck',
				label: 'Were you on your assigned truck at time of incident?',
				...yesNoEnum,
				isRequired,
			},
			{
				path: 'didYouNoteAnyMaintenanceIssuesOnTruck',
				label: 'Did you note any maintenance issues on the truck?',
				...yesNoEnum,
				isRequired,
			},

			{ section: 'Work Load' },
			{
				path: 'howManyHoursOfWorkWereYouDispatched',
				label: 'How many hours of work were you dispatched?',
				type: 'string',
			},
			{
				path: 'howManyLoadsWereOnYourShift',
				label: 'How many loads were on your shift?',
				type: 'string',
			},
			{
				path: 'didAnyOfYourWorkGetChangedOrRevised',
				label: 'Did any of your work get changed or revised?  If so, explain.',
				...questionMulti,
			},
			{
				path: 'whatLoadOfTheShiftDidTheMixOccur',
				label: 'Which load of the shift did the mix occur (1st of 4; 3rd of 5)?',
				type: 'string',
			},
			{
				path: 'whatActionsDidYouTakeImmediatelyFollowingTheMix',
				label: 'What actions did you take immediately following the mix?',
				...questionMulti,
			},
			{
				path: 'haveYourMadePastDeliveriesToThisStation',
				label: 'Have you made past deliveries to this station?',
				...yesNoEnum,
				isRequired,
			},
			{
				path: 'howDidYouReferenceTheJourneyPlan',
				label: 'How did you reference the journey plan?  Was it correct?',
				...questionMulti,
			},
			{ section: 'Procedures/Training' },
			{
				path: 'explainYourStepsAndTheSequenceForLoadProduct',
				label: 'Explain your steps and the sequence in which you load product.',
				...questionMulti,
			},
			{
				path: 'describeHowYourVerifyCompartmentProductTagsAgainstTheBol',
				label: 'Describe how you verify compartment product tags against the BOL after loading.',
				...questionMulti,
			},
			{
				path: 'doYouUseAnySpecialEquipmentWhenUnloading',
				label: 'Do you use any special equipment/tools when unloading (colored cones, tags, etc.)?',
				...questionMulti,
			},
			{
				path: 'tellUsABitAboutWhatWasGoingOnDuringLoading',
				label:
					'Tell us a bit about what was going on during loading (rack congestion, maintenance issues, delays, supply issues, etc.)',
				...questionMulti,
			},
			{
				path: 'doesYourCompanyProvideWrittenProceduresForLoading',
				label:
					'Does your company provide written procedures for loading/ unloading? When was the last time you reviewed them?',
				...questionMulti,
			},
			{
				path: 'howDoYouVerifyTheProductTypeInEachTruck',
				label:
					'How do you verify the product type in each truck/trailer compartment before delivery?',
				...questionMulti,
			},
			{
				path: 'explainYourStepsAndSequenceInWhichYourUnloadProduct',
				label: 'Explain your steps and sequence in which you unload product.',
				...questionMulti,
			},
			{
				path: 'didYouDoubleHoseDoYouHaveHoseTraining',
				label:
					'Did you double hose?  Does your company policy or past training mention anything about laying out hoses when delivering two products at the same time? Explain the process.',
				...questionMulti,
			},
			{
				path: 'tellUseABitAboutWhatWasGoingOnDuringUnloading',
				label:
					'Tell us a bit about what was going on during unloading (station congestion, maintenance, etc.)?',
				...questionMulti,
			},
			{
				path: 'describeAnyProblemsOrDistractions',
				label:
					'Describe any problems or distractions that occurred during loading, while driving, or unloading.',
				...questionMulti,
			},
			{
				path: 'whatWereTheConditionsWhileUnloading',
				label: 'What were the conditions while unloading (rain, wind, heat, etc.)?',
				...questionMulti,
			},
			{
				path: 'wasThereAnythingThatCausedYouTOGetOutOfNormalRoutine',
				label:
					'Was there anything that caused you to get out of your normal routine?  If so, what?',
				...questionMulti,
			},
			{
				path: 'whatDoYouDoWhenYouAreInterruptedDuringDelivery',
				label:
					'What do you do when you are interrupted during a delivery?  What does your company policy recommend you do?',
				...questionMulti,
			},
			{
				path: 'haveYouEverHadAMixIfSoWhen',
				label: 'Have you ever had a mix?  If so, when?',
				...questionMulti,
			},
			{
				path: 'whatWereTheLessonsLearned',
				label: 'What were the lessons learned?',
				...questionMulti,
			},

			{ section: 'Reconciliation' },
			{
				path: 'areYouAwareOfVeederRootReconciliationRequirements',
				label: 'Are you aware of the Veeder Root reconciliation requirements?',
				...yesNoEnum,
				isRequired,
			},
			{
				path: 'canYouExplainTheSteps',
				label: 'Can you explain the steps?',
				...questionMulti,
			},

			{ section: 'Stop Work Authority' },
			{
				path: 'stopWorkAuthority',
				label: 'Are you aware of Stop Work Authority Policy?',
				...yesNoEnum,
				isRequired,
			},
			{
				path: 'canYouGiveAnExampleOfHowYouUsePolicy',
				label: 'Can you give an example of how you would use the policy?',
				...questionMulti,
			},
			{ section: 'General' },
			{
				path: 'isThereAnythingYouWouldLikeToShare',
				label: 'Is there anything you would like to share that we haven’t already talked about?',
				...questionMulti,
				lines: 7,
			},

			...formGroups.driverSignature,
		],
		printFields: [
			...printGroups.tripInfo,
			[
				{ path: 'dateOfIncident', basis: 50 },
				{ path: 'timeOfIncident', basis: 50 },
			],
			[{ path: 'fuelType' }, { path: 'totalGallons' }],
			...printGroups.siteLocation,
			[{ special: 'reportedTo' }],
			[{ path: 'contaminationExplanation', height: 40 }],
			{ isPageBreak },
			[{ path: 'howCouldHaveBeenPrevented', height: 30 }],
			[{ path: 'actionTakenToCorrect', height: 30 }],
			[{ special: 'driverSignature' }],

			{ isPageBreak },
			[{ special: 'mixTitle' }],
			[{ special: 'company' }],
			[
				{ path: 'dateOfIncident', basis: 50 },
				{ path: 'timeOfIncident', basis: 50 },
			],
			[{ path: 'stationNumber' }],
			[{ path: 'productsInvolved' }],

			{ section: 'History' },
			[{ path: 'tankTruckDrivingExperience' }],
			[{ path: 'dateOfHire' }],

			{ section: 'Schedule' },
			[{ path: 'dayShiftOrNightShift' }, { path: 'doYouRotate' }],
			[{ path: 'timeShiftStarted' }, { path: 'didYouGetAdequateRest' }],
			[{ path: 'whatTypeOfSchedule' }],
			[{ path: 'whatDayOfYourWorkWeekDidTheIncidentOccur' }],

			{ section: 'Truck / Equipment' },
			[{ path: 'doYouHaveAnAssignedTruck' }],
			[{ path: 'wereYouOnYourAssignedTruck' }],
			[{ path: 'didYouNoteAnyMaintenanceIssuesOnTruck' }],

			{ section: 'Work Load' },
			[{ path: 'howManyHoursOfWorkWereYouDispatched' }],
			[{ path: 'howManyLoadsWereOnYourShift' }],
			[{ path: 'whatLoadOfTheShiftDidTheMixOccur' }],
			[{ path: 'haveYourMadePastDeliveriesToThisStation' }],
			{ isPageBreak },

			[{ path: 'didAnyOfYourWorkGetChangedOrRevised' }],
			[{ path: 'whatActionsDidYouTakeImmediatelyFollowingTheMix' }],
			[{ path: 'howDidYouReferenceTheJourneyPlan' }],

			{ section: 'Procedures/Training' },
			[{ path: 'explainYourStepsAndTheSequenceForLoadProduct' }],
			[{ path: 'describeHowYourVerifyCompartmentProductTagsAgainstTheBol' }],
			[{ path: 'doYouUseAnySpecialEquipmentWhenUnloading' }],
			{ isPageBreak },
			[{ path: 'tellUsABitAboutWhatWasGoingOnDuringLoading' }],
			[{ path: 'doesYourCompanyProvideWrittenProceduresForLoading' }],
			[{ path: 'howDoYouVerifyTheProductTypeInEachTruck' }],
			[{ path: 'explainYourStepsAndSequenceInWhichYourUnloadProduct' }],
			[{ path: 'didYouDoubleHoseDoYouHaveHoseTraining' }],
			[{ path: 'tellUseABitAboutWhatWasGoingOnDuringUnloading' }],
			{ isPageBreak },
			[{ path: 'describeAnyProblemsOrDistractions' }],
			[{ path: 'whatWereTheConditionsWhileUnloading' }],
			[{ path: 'wasThereAnythingThatCausedYouTOGetOutOfNormalRoutine' }],
			[{ path: 'whatDoYouDoWhenYouAreInterruptedDuringDelivery' }],
			[{ path: 'haveYouEverHadAMixIfSoWhen' }],
			[{ path: 'whatWereTheLessonsLearned' }],

			{ isPageBreak },
			{ section: 'Reconciliation' },
			[{ path: 'areYouAwareOfVeederRootReconciliationRequirements' }],
			[{ path: 'canYouExplainTheSteps' }],

			{ section: 'Stop Work Authority' },
			[{ path: 'stopWorkAuthority' }],
			[{ path: 'canYouGiveAnExampleOfHowYouUsePolicy' }],

			{ section: 'General' },
			[{ path: 'isThereAnythingYouWouldLikeToShare', height: 18 }],
			[{ special: 'driverSignature' }],
		],
	},
	accident: {
		title: 'Truck Accident Report',
		formFields: [
			...formGroups.tripInfo,
			fields.commercialTruckDrivingExperience,

			{ section: 'Accident Info' },
			[
				{
					path: 'dateOfAccident',
					label: 'Date of Accident',
					type: 'date',
					isRequired,
				},
				{
					path: 'timeOfAccident',
					label: 'Time of Accident',
					type: 'time',
					isRequired,
				},
			],
			[
				{ path: 'weather', label: 'Weather', type: 'string' },
				{ path: 'truckSpeed', label: 'Truck Speed', type: 'string' },
			],
			{
				path: 'locationOfAccident',
				label: 'Location of Accident',
				type: 'string',
				isRequired,
			},

			{ section: 'Damage Info' },
			{
				path: 'damageToOurEquipment',
				label: 'Damage to our equipment (explain extent)',
				type: 'multilineString',
				lines: 2,
				isRequired,
			},
			[
				{
					path: 'anyReleaseOfHazMat',
					label: 'Any release of haz mat?',
					...yesNoEnum,
					isRequired,
				},
				{
					path: 'contentsInTankAtTimeOfAccident',
					label: 'Contents in tank at time of accident',
					type: 'enum',
					options: [
						{ display: 'Full', value: 'full' },
						{ display: 'Part', value: 'part' },
						{ display: 'Empty', value: 'empty' },
					],
					isRequired,
				},
			],
			{
				path: 'didAnyProductSpill',
				label: 'Did any product spill?',
				...yesNoEnum,
				isRequired,
			},
			{
				note:
					'If any amount of product spilled from cargo tank you MUST complete a spill report from',
			},
			{ section: 'Other Vehicle #1' },
			...formGroups.vehicle1,

			{ section: 'Other Vehicle #2' },
			...formGroups.vehicle2,

			{ section: 'Accident Details' },
			{
				path: 'detailedDescriptionOfAccident',
				label: 'Detailed Description of Accident',
				type: 'multilineString',
				lines: 12,
				isRequired,
			},
			{
				path: 'couldThisHaveBeenPrevented',
				label: 'Could this have been prevented?',
				...yesNoEnum,
				isRequired,
			},
			{
				path: 'howCouldItHaveBeenPrevented',
				label: 'How could it have been prevented',
				type: 'multilineString',
				lines: 6,
			},
			[
				{
					path: 'anyPersonsUseAmbulance',
					label: 'Any persons transported by ambulance',
					...yesNoEnum,
					isRequired,
				},
				{
					path: 'areYouInjured',
					label: 'Are you injured?',
					...yesNoEnum,
					isRequired,
				},
			],
			[
				{
					path: 'accidentReportIssuedBy',
					label: 'Accident report issued by',
					type: 'string',
					isRequired,
				},
				{
					path: 'picturesTaken',
					label: 'Pictures taken?',
					...yesNoEnum,
					isRequired,
				},
			],
			{
				path: 'accidentDrawing',
				label: 'Accident Drawing',
				type: 'accidentDrawing',
			},
			...formGroups.driverSignature,
		],
		printFields: [
			...printGroups.tripInfo,
			[{ path: 'commercialTruckDrivingExperience' }],
			[{ path: 'dateOfAccident' }, { path: 'timeOfAccident' }],
			[{ path: 'weather' }, { path: 'truckSpeed' }],
			[{ path: 'locationOfAccident' }],
			[{ path: 'damageToOurEquipment', height: 40 }],
			[{ path: 'anyReleaseOfHazMat' }, { path: 'contentsInTankAtTimeOfAccident' }],
			[{ path: 'anyPersonsUseAmbulance' }, { path: 'areYouInjured' }],
			[{ path: 'accidentReportIssuedBy' }, { path: 'picturesTaken' }],
			{ isPageBreak },
			...printGroups.vehicle1,
			...printGroups.vehicle2,
			{ isPageBreak },
			[{ path: 'detailedDescriptionOfAccident', height: 90 }],
			{ isPageBreak },
			[{ path: 'couldThisHaveBeenPrevented' }],
			[{ path: 'howCouldItHaveBeenPrevented', height: 50 }],
			[{ special: 'accidentDrawing' }],
			[{ special: 'driverSignature' }],
		],
	},
	incident: {
		title: 'Incident Report',
		formFields: [
			...formGroups.tripInfo,
			fields.tankTruckDrivingExperience,

			{ section: 'Incident Details' },
			[fields.dateOfIncident, fields.timeOfIncident],
			[
				{
					path: 'typeOfIncident',
					label: 'Type of Incident',
					isRequired,
					type: 'enum',
					options: [
						{ display: 'Dome Out', value: 'domeOut' },
						{ display: 'Customer Miss-Load', value: 'customerMissLoad' },
						{ display: 'Wrong Station', value: 'wrongStation' },
						{ display: 'Other Incident', value: 'otherIncident' },
					],
				},
				fields.anyInjuries,
			],
			{
				path: 'locationOfIncident',
				label: 'Location of Incident',
				type: 'string',
				isRequired,
			},

			...formGroups.reportedTo,

			{ section: 'Incident Writeup' },
			{
				path: 'detailedDescriptionOfIncident',
				label: 'Detailed description of incident',
				type: 'multilineString',
				lines: 9,
				isRequired,
			},
			{
				path: 'measuresToBeTakenToPrevent',
				label: 'Measures to be taken to prevent a similar occurrence',
				type: 'multilineString',
				lines: 5,
			},
			...formGroups.driverSignature,
		],
		printFields: [
			...printGroups.tripInfo,
			[{ path: 'tankTruckDrivingExperience' }],
			[
				{ path: 'dateOfIncident', basis: 50 },
				{ path: 'timeOfIncident', basis: 50 },
			],
			[{ path: 'typeOfIncident' }, { path: 'anyInjuries' }],
			[{ path: `locationOfIncident` }],
			[{ special: 'reportedTo' }],

			{ isPageBreak },
			[{ path: 'detailedDescriptionOfIncident', height: 70 }],
			[{ path: 'measuresToBeTakenToPrevent', height: 20 }],
			[{ special: 'driverSignature' }],
		],
	},
	spill: {
		title: 'Product Spill Report',
		formFields: [
			...formGroups.tripInfo,
			fields.tankTruckDrivingExperience,

			{ section: 'Spill Details' },
			[fields.dateOfIncident, fields.timeOfIncident],
			...formGroups.siteLocation,
			[fields.fuelType, fields.totalGallons],
			[
				{
					path: 'spillContactConcrete',
					label: 'Spill contact concrete',
					...yesNoEnum,
					isRequired,
				},
				{
					path: 'spillContactAsphalt',
					label: 'Spill contact asphalt',
					...yesNoEnum,
					isRequired,
				},
			],
			[
				{
					path: 'spillContactDirt',
					label: 'Spill contact dirt',
					...yesNoEnum,
					isRequired,
				},
				fields.anyInjuries,
			],
			{
				path: 'didSpillReachSewers',
				label: 'Did spill reach any public street or sewers',
				...yesNoEnum,
				isRequired,
			},
			...formGroups.reportedTo,
			{ section: 'Spill Writeup' },
			{
				path: 'detailedDescriptionOfSpill',
				label: 'Detailed description of spill',
				type: 'multilineString',
				lines: 9,
				isRequired,
			},
			{
				path: 'describeDamageToProperty',
				label: 'Describe damage to property',
				type: 'multilineString',
				lines: 5,
			},
			{
				path: 'couldThisSpillHaveBeenPrevented',
				label: 'Could this spill have been prevented?',
				...yesNoEnum,
				isRequired,
			},
			{
				path: 'howCouldSpillHaveBeenPrevented',
				label: 'How could have this spill been prevented',
				type: 'multilineString',
				lines: 5,
			},
			...formGroups.driverSignature,
		],
		printFields: [
			...printGroups.tripInfo,
			[{ path: 'tankTruckDrivingExperience' }],
			[
				{ path: 'dateOfIncident', basis: 50 },
				{ path: 'timeOfIncident', basis: 50 },
			],
			...printGroups.siteLocation,
			[{ path: 'fuelType' }, { path: 'totalGallons' }],
			[{ path: 'spillContactConcrete' }, { path: 'spillContactAsphalt' }],
			[{ path: 'spillContactDirt' }, { path: 'anyInjuries' }],
			[{ special: 'reportedTo' }],

			[{ path: 'didSpillReachSewers' }],
			[{ path: 'describeDamageToProperty', height: 30 }],
			{ isPageBreak },
			[{ path: 'detailedDescriptionOfSpill', height: 60 }],
			[{ path: 'couldThisSpillHaveBeenPrevented' }],
			[{ path: 'howCouldSpillHaveBeenPrevented', height: 15 }],
			[{ special: 'driverSignature' }],
		],
	},
	injury: {
		title: 'Injury Report',
		formFields: [
			[
				//{path: 'socialSecurityNumber', label: 'Social Security #', type: 'string', isRequired},
				{ path: 'gender', label: 'Gender', ...genderEnum, isRequired },
			],
			{
				path: 'homeAddress',
				label: 'Home Address',
				type: 'string',
				isRequired,
			},
			[
				{ path: 'phoneNumber', label: 'Phone #', type: 'string', isRequired },
				{
					path: 'alternatePhoneNumber',
					label: 'Alternate Phone #',
					type: 'string',
				},
			],
			[fields.dateOfBirth, fields.dateOfHire],

			...formGroups.tripInfo,

			{ section: 'Injury Info' },
			[
				{
					path: 'dateOfInjury',
					label: 'Date of injury',
					type: 'date',
					isRequired,
				},
				{
					path: 'timeOfInjury',
					label: 'Time of injury',
					type: 'time',
					isRequired,
				},
			],
			[
				{
					path: 'dateInjuryReported',
					label: 'Date injury was reported',
					type: 'date',
					isRequired,
				},
				{
					path: 'timeInjuryReported',
					label: 'Time injury was reported',
					type: 'time',
					isRequired,
				},
			],
			{
				path: 'locationWhereInjuryOccurred',
				label: 'Location where injury occurred',
				type: 'string',
				isRequired,
			},
			...formGroups.reportedTo,

			{ section: 'Injury Details' },
			{
				path: 'equipmentUsingWhenInjuryOccurred',
				label: 'Equipment, material, or chemicals you were using when injury/event occurred',
				type: 'multilineString',
				lines: 2,
				isRequired,
			},
			{
				path: 'specificActivityWhenInjuryOccurred',
				label: 'Specific activity you were performing when injury/event occurred',
				type: 'multilineString',
				lines: 2,
				isRequired,
			},
			{
				path: 'detailedDescriptionOfHowInjuryOccurred',
				label: 'Detailed description of how injury occurred',
				type: 'multilineString',
				lines: 5,
				isRequired,
			},
			{
				path: 'specificInjuryAndPartOfBodyAffected',
				label: 'Specific injury and part of body affected, medical diagnosis (if available)',
				type: 'multilineString',
				lines: 2,
				isRequired,
			},
			{
				path: 'partOfBodyAffectedByAPriorInjury',
				label: 'Part of body affected by a prior industrial injury',
				...yesNoEnum,
				isRequired,
			},
			{
				path: 'doYouNeedToSeekMedicalTreatment',
				label: 'Do you need to seek medical treatment at this time',
				...yesNoEnum,
				isRequired,
			},
			...formGroups.driverSignature,
		],
		printFields: [
			[{ path: 'driverName', label: `Driver's Name` }, { path: 'gender' }],
			[{ path: 'homeAddress' }],
			[{ path: 'phoneNumber' }, { path: 'alternatePhoneNumber' }],
			[{ path: 'dateOfBirth' }, { path: 'dateOfHire' }],
			[
				{ path: 'dateShiftStarted', basis: 50 },
				{ path: 'timeShiftStarted', basis: 50 },
			],
			[
				{ path: 'baseTerminal', basis: 50 },
				{ path: 'shipperCustomer', basis: 50 },
			],
			[{ path: `truckTrailerNumber` }, { path: 'bolNumber', label: `BOL #` }],
			[{ path: 'dateOfInjury' }, { path: 'timeOfInjury' }],
			[{ path: 'dateInjuryReported' }, { path: 'timeInjuryReported' }],
			[{ path: 'locationWhereInjuryOccurred' }],
			[{ special: 'reportedTo' }],

			[{ path: 'equipmentUsingWhenInjuryOccurred', height: 20 }],
			{ isPageBreak },
			[{ path: 'specificActivityWhenInjuryOccurred' }],
			[{ path: 'detailedDescriptionOfHowInjuryOccurred', height: 50 }],
			[{ path: 'specificInjuryAndPartOfBodyAffected' }],
			[{ path: 'partOfBodyAffectedByAPriorInjury' }],
			[{ path: 'doYouNeedToSeekMedicalTreatment' }],
			[{ special: 'driverSignature' }],
		],
	},
	waitingForTruck: {
		title: 'Waiting For Truck',
		doNotShowTicketDetails: true,
		formFields: [
			...formGroups.optionalTripInfo,
			{ section: 'Event Details' },
			[fields.dateOfWait, fields.timeOfWait],
			[
				{
					path: 'waitingReason',
					label: 'Wait Reason',
					isRequired,
					type: 'enum',
					options: [
						{ display: 'Mechanical', value: 'mechanical' },
						{ display: 'Truck not back', value: 'truckNotBack' },
						{ display: 'Dispatch not ready', value: 'dispatchNotReady' },
						{ display: 'Other Reason', value: 'otherReason' },
					],
				},
			],
			{
				path: 'waitingOnTruckNumber',
				label: 'Waiting on which truck number',
				type: 'string',
				isRequired,
			},

			{
				path: 'wasAnotherTruckOffered',
				label: 'Was another truck requested or offered?',
				...yesNoEnum,
				isRequired,
			},
			{
				path: 'wasAnotherTruckAvailable',
				label: 'Was another truck available for your scheduled work?',
				...yesNoEnum,
				isRequired,
			},

			...formGroups.reportedTo,

			{ section: 'Event Writeup' },
			{
				path: 'detailedDescriptionOfIncident',
				label: 'Detailed description of why waiting for truck',
				type: 'multilineString',
				lines: 7,
				isRequired,
			},
			...formGroups.driverSignature,
		],
		printFields: [
			...printGroups.optionalTripInfo,
			[
				{ path: 'dateOfWait', basis: 50 },
				{ path: 'timeOfWait', basis: 50 },
			],
			[{ path: 'waitingReason' }],
			[{ path: `waitingOnTruckNumber` }],
			[{ path: `wasAnotherTruckOffered` }],
			[{ path: `wasAnotherTruckAvailable` }],
			[{ special: 'reportedTo' }],
			// { isPageBreak },
			[{ path: 'detailedDescriptionOfIncident', height: 50 }],
			[{ special: 'driverSignature' }],
		],
	},
	nearMissReport: {
		title: 'Self-Reported Near Miss Report Setup',
		formFields: [
			{ section: 'Near Miss Info' },
			[
				{ path: 'baseTerminal', label: 'Driver Terminal', type: 'string' },
				{ path: 'truckTrailerNumber', label: 'Truck / Trailer #', type: 'string' },
			],
			[
				{ path: 'shipperCustomer', label: 'Customer', type: 'string' },
				{ path: 'orderNumber', label: 'Order Number', type: 'string' },
			],
			[
				{ path: 'dateOfNearMiss', label: 'Date of near miss', type: 'date', isRequired },
				{ path: 'timeOfNearMiss', label: 'Time of near miss', type: 'time', isRequired },
			],
			{
				path: 'nearMissSeverity',
				label: 'Rate your near miss (0 = least severe, 10 = most severe)',
				type: 'enum',
				options: [
					{ display: '0', value: '0' },
					{ display: '1', value: '1' },
					{ display: '2', value: '2' },
					{ display: '3', value: '3' },
					{ display: '4', value: '4' },
					{ display: '5', value: '5' },
					{ display: '6', value: '6' },
					{ display: '7', value: '7' },
					{ display: '8', value: '8' },
					{ display: '9', value: '9' },
					{ display: '10', value: '10' },
				],
				isRequired,
			},
			{
				path: 'locationOfNearMiss',
				label: 'Location (street, terminal, freeway, customer site)',
				type: 'string',
				isRequired,
			},
			{
				path: 'nearMissDetails',
				label:
					'Provide a detailed statement of what the near miss was, how you caught the issue, how you avoided it progressing, and whether you contacted anyone to assist',
				type: 'multilineString',
				lines: 10,
				isRequired,
			},
			{
				path: 'nearMissRecommendedSolution',
				label:
					'Recommended solution to correct the situation or what could be done to prevent similar issues',
				type: 'multilineString',
				lines: 6,
			},
		],
		printFields: [
			[
				{ path: 'driverName', label: `Driver's Name`, basis: 50 },
				{ path: 'truckTrailerNumber', label: 'Truck / Trailer #', basis: 50 },
			],
			[
				{ path: 'baseTerminal', label: 'Driver Terminal', basis: 50 },
				{ path: 'shipperCustomer', label: 'Customer', basis: 50 },
			],
			[{ path: 'orderNumber', label: 'Order Number' }],
			[
				{ path: 'dateOfNearMiss', label: 'Date of near miss', basis: 50 },
				{ path: 'timeOfNearMiss', label: 'Time of near miss', basis: 50 },
			],
			[{ path: 'nearMissSeverity', label: 'Near Miss Severity (0-10)' }],
			[{ path: 'locationOfNearMiss', label: 'Location' }],
			[{ path: 'nearMissDetails', label: 'Details', height: 60 }],
			{ isPageBreak },
			[{ path: 'nearMissRecommendedSolution', label: 'Recommended Solution', height: 30 }],
		],
	},
};

_.keys(infoByReportType).forEach((reportType) => {
	const formFields = infoByReportType[reportType].formFields;

	const fieldsByPath = {};
	formFields.forEach((formField) => {
		const fields = _.isArray(formField) ? formField : [formField];

		fields.forEach((field) => {
			const { path, section, note } = field;
			if (section || note) {
				return;
			}
			fieldsByPath[path] = field;
		});
	});

	const printFields = infoByReportType[reportType].printFields;

	printFields.forEach((printField) => {
		const fields = _.isArray(printField) ? printField : [printField];
		fields.forEach((field) => {
			const { path } = field;

			if (fieldsByPath[path]) {
				_.defaults(field, fieldsByPath[path]);
			}
		});
	});
});

export { infoByReportType };
